import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";

import { TextField, Button } from "@material-ui/core";
import axios from "../../../axios";
import { setLoading } from "../../../actions";
import InputMask from "react-input-mask";

export const BankingInfoComponent = ({
  permissions,
  is_super_admin,
  optionsRecord,
  submitRecord,
  errorObj,
  lang,
  showPasswordsManager,
  isUpdate = false,
  showMessage,
  handleAppError,
  setLoading,
}) => {
  console.log({ optionsRecord });
  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
  } = useForm({
    defaultValues: {
      bankaccountname: optionsRecord.bankaccountname,
      iban: optionsRecord.iban,
      bankname: optionsRecord.bankname,
      bankcardnumber: optionsRecord.bankcardnumber,
      bankcardholdername: optionsRecord.bankcardholdername,
      bankcardexpirydate: optionsRecord.bankcardexpirydate,
      bankcardcvv: optionsRecord.bankcardcvv,
    },
  });
  useEffect(() => {
    if (errorObj) {
      console.log("setting errors ...");
      Object.keys(errorObj).forEach((key) => {
        setError(key, { type: "custom", message: errorObj[key][0] });
      });
    }
  }, [errorObj]);
  const validationMessages = (error, fieldName = "This field") => {
    if (error.type === "required") {
      return (
        window.sys_app_translate(fieldName, lang) +
        " " +
        window.sys_app_translate("is required", lang)
      );
    }
    if (error.type === "pattern") {
      switch (fieldName) {
        default:
          return (
            window.sys_app_translate(fieldName, lang) +
            " " +
            window.sys_app_translate("is not correct", lang)
          );
      }
    }
    if (error.type === "custom") {
      return error.message;
    }
  };
  const fileRef = useRef(null);
  const onSubmit = (values) => {
    console.log("submitting options ...");
    optionsRecord.bankaccountname = values.bankaccountname;
    optionsRecord.iban = values.iban;
    optionsRecord.bankname = values.bankname;

    optionsRecord.bankcardnumber = values.bankcardnumber
      ? values.bankcardnumber.replace(/\s+/g, "")
      : values.bankcardnumber;
    optionsRecord.bankcardholdername = values.bankcardholdername;
    optionsRecord.bankcardexpirydate = values.bankcardexpirydate;
    optionsRecord.bankcardcvv = values.bankcardcvv;

    submitRecord(optionsRecord);
    return;
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row" style={{ marginTop: "1.5rem" }}>
          <div className="col-12 my-2 offset-1 offset-sm-0">
            <span style={{ fontWeight: "bold" }}>
              {window.sys_app_translate("System Credit Card Info", lang)}
            </span>
          </div>
        </div>
        {/*bankcardnumber*/}
        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <Controller
              name="bankcardnumber"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <InputMask
                  mask="9999 9999 9999 9999"
                  maskChar="_"
                  disabled={false}
                  {...field}
                >
                  {(inputProps) => (
                    <TextField
                      id="BankCardNumber"
                      className="itqan-text-field"
                      label={window.sys_app_translate("Bank Card Number", lang)}
                      variant="outlined"
                      error={errors.bankcardnumber ? true : false}
                      helperText={
                        errors.bankcardnumber &&
                        validationMessages(errors.bankcardnumber, "Note")
                      }
                      {...field}
                    />
                  )}
                </InputMask>
              )}
            />
          </div>
        </div>
        {/*bankcardholdername*/}
        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <Controller
              name="bankcardholdername"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <TextField
                  id="BankCardHolderName"
                  className="itqan-text-field"
                  label={window.sys_app_translate(
                    "Bank Card Holder Name",
                    lang,
                  )}
                  variant="outlined"
                  error={errors.bankcardholdername ? true : false}
                  helperText={
                    errors.bankcardholdername &&
                    validationMessages(errors.bankcardholdername, "Note")
                  }
                  {...field}
                />
              )}
            />
          </div>
        </div>
        {/*bankcardexpirydate*/}
        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <Controller
              name="bankcardexpirydate"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <InputMask
                  mask="99/9999"
                  maskChar="_"
                  disabled={false}
                  {...field}
                >
                  {(inputProps) => (
                    <TextField
                      id="BankCardExpiryDate"
                      className="itqan-text-field"
                      label={window.sys_app_translate(
                        "Bank Card Expiry Date (MM/YY)",
                        lang,
                      )}
                      variant="outlined"
                      error={errors.bankcardexpirydate ? true : false}
                      helperText={
                        errors.bankcardexpirydate &&
                        validationMessages(errors.bankcardexpirydate, "Note")
                      }
                      {...field}
                    />
                  )}
                </InputMask>
              )}
            />
          </div>
        </div>
        {/*bankcardcvv*/}
        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <Controller
              name="bankcardcvv"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <InputMask mask="999" maskChar="_" disabled={false} {...field}>
                  {(inputProps) => (
                    <TextField
                      id="BankCardCVV"
                      className="itqan-text-field"
                      label={window.sys_app_translate("Bank Card CVV", lang)}
                      variant="outlined"
                      error={errors.bankcardcvv ? true : false}
                      helperText={
                        errors.bankcardcvv &&
                        validationMessages(errors.bankcardcvv, "Note")
                      }
                      {...field}
                    />
                  )}
                </InputMask>
              )}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <hr style={{ marginTop: "1.5rem", marginBottom: "0.5rem" }} />
          </div>
        </div>

        {/*bankaccountname*/}
        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <Controller
              name="bankaccountname"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <TextField
                  id="BankAccountName"
                  className="itqan-text-field"
                  label={window.sys_app_translate("Bank Account Name", lang)}
                  variant="outlined"
                  error={errors.bankaccountname ? true : false}
                  helperText={
                    errors.bankaccountname &&
                    validationMessages(errors.bankaccountname, "Note")
                  }
                  {...field}
                />
              )}
            />
          </div>
        </div>
        {/*iban*/}
        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <Controller
              name="iban"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <TextField
                  id="IBAN"
                  className="itqan-text-field"
                  label={window.sys_app_translate("IBAN", lang)}
                  variant="outlined"
                  error={errors.iban ? true : false}
                  helperText={
                    errors.iban && validationMessages(errors.iban, "Note")
                  }
                  {...field}
                />
              )}
            />
          </div>
        </div>
        {/*bankname*/}
        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <Controller
              name="bankname"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <TextField
                  id="BankName"
                  className="itqan-text-field"
                  label={window.sys_app_translate("Bank Name", lang)}
                  variant="outlined"
                  error={errors.bankname ? true : false}
                  helperText={
                    errors.bankname &&
                    validationMessages(errors.bankname, "Note")
                  }
                  {...field}
                />
              )}
            />
          </div>
        </div>

        {/*Submit button*/}
        <div
          className="row d-flex justify-content-start form-row"
          style={{ marginTop: "1rem" }}
        >
          <div className="col-10 offset-1 col-sm-6 offset-sm-0 d-flex justify-content-start">
            <Button
              variant="contained"
              style={{ display: "inline" }}
              type="submit"
              className="itqan-form-button"
              onClick={() => {}}
            >
              {window.sys_app_translate("Update", lang)}
            </Button>
          </div>
        </div>
      </form>
    </React.Fragment>
  );
};
